import React, { useState, useEffect } from "react";
import Contaier from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import Banner from "../../components/layout/Sections/Banner";

let bannerName = "Application Details for Assurance Certification Scheme (ACS)";

function AcsApplicationForm() {

  interface NominationRecord {
  ocrPersonName: string;
  ocrPersonDesignation: string;
  mgmtReviewPerson: string;
  mgmtReviewDesignation: string;
}

interface ScheduleCountries {
  country: string;
  product: string;
  additionalCertReq: string;
}

interface OtherStaffsAcs{
  personnelNameOthers: string;
  personnelPositionOthers: string;
}
//const formRef = React.useRef<HTMLFormElement | null>(null);

interface acsApplicationForm{
  chiefExecutiveDeclaration:string;
  acsQaPolicyObjectives: string;
  scopeOfPcActivities:string;
  dsChiefExecutiveName:string;
  dsMgmtRepName:string;
  orgChartDoc:string;
  toMaintainRecords:string;
  firstPersonnelFullName:string;
  firstPersonnelPosition:string;
  secondPersonnelFullName:string;
  secondPersonnelPosition:string;
  exportInsPersonnelName:string;
  exportInsPersonnelPosition:string;
  qasRawMaterialIncPerson:string;
  qasExportMaterialIncPerson: string;
  qasExportCertIncPerson: string;
  qasPITControlPerson:string;
}

const [formData, setFormData] = useState<NominationRecord>({
  ocrPersonName: "",
  ocrPersonDesignation: "",
  mgmtReviewPerson: "",
  mgmtReviewDesignation: "",
});
const [scFormData, setSCFormData] = useState<ScheduleCountries>({
  country: "",
  product: "",
  additionalCertReq: ""
});
const [acsFormData, setAcsFormData] = useState<OtherStaffsAcs>({
  personnelNameOthers: "",
  personnelPositionOthers: ""
});

const [records, setRecords] = useState<NominationRecord[]>([]);
const [scheduleCountries, setScheduleCountries] = useState<ScheduleCountries[]>([]);
const [acsOtherStaffs, setAcsOtherStaffs] = useState<OtherStaffsAcs[]>([]);

const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  setFormData({
    ...formData,
    [e.target.name]: e.target.value,
  });
  setSCFormData({
    ...scFormData,
    [e.target.name]: e.target.value,
  });
  setAcsFormData({
    ...acsFormData,
    [e.target.name]: e.target.value,
  });
};

const handleAdd = () => {
  setRecords([...records, { ...formData }]);
  setFormData({
    ocrPersonName: "",
    ocrPersonDesignation: "",
    mgmtReviewPerson: "",
    mgmtReviewDesignation: "",
  });
};

const handleAddSc = () => {
  setScheduleCountries([...scheduleCountries, { ...scFormData }]);
  setSCFormData({
    country: "",
  product: "",
  additionalCertReq: ""
  });
};

const handleAddAcsStaff = () => {
  setAcsOtherStaffs([...acsOtherStaffs, { ...acsFormData }]);
  setAcsFormData({
  personnelNameOthers: "",
  personnelPositionOthers: ""
  });
};

const handleDelete = (index: number) => {
  const newRecords = records.filter((_, i) => i !== index);
  setRecords(newRecords);
};

const handleDeleteSc = (index: number) => {
  const newRecords = scheduleCountries.filter((_, i) => i !== index);
  setScheduleCountries(newRecords);
};

const handleDeleteAcsStaff = (index: number) => {
  const newRecords = acsOtherStaffs.filter((_, i) => i !== index);
  setAcsOtherStaffs(newRecords);
};

// const handleCancel = () => {
//     formRef.current?.reset();
//   };

return (
    <>
    <Header />
    <Contaier>
        <Banner name={bannerName} uiClass="banner-bg" />
         {/* <form ref={formRef}> */}
        <div className="inner-content">
          <div className="container">
            <div className="row">
              <p><h2><b>1. Declaration by Chief Executive (CE)</b></h2></p>
              <p>Management Responsibilities</p>
              <p>Declaration by Chief Executive</p>
              <div className="mb-3 form-check">
                  <input
                        type="checkbox"
                        className="form-check-input"
                        id="mgmtResponsibilities"
                        // checked={isNewAddress}
                        // onChange={handleCheckboxChangeEditMailingAddress}
                  />
                  <label
                        className="form-check-label"
                        htmlFor="mgmtResponsibilities"
                  >
                        I, being the owner or managing director of the registered company, hereby declare to all staff and to NParks that I undertake, on behalf of the company to: a) Ensure compliance with the Terms and Conditions of the Approved Assurance Certification Scheme (ACS) arrangement b) Comply with the policies, procedures and specifications set out in this manual which defines the quality system in operation for the preparation of the products specified in the schedule of products. c) Grant entry to the premises at any time to persons who are NParks authorized officers for the purpose of the approved ACS arrangement. This entry includes for the purposes of formally auditing matters contained in the manual and monitoring performance of all activities related to inspections, certification and legislative requirements. I understand that being committed to the approved ACS arrangement is essential to the successful maintenance of the arrangement and I will endeavour to ensure that all personnel (particularly those responsible for critical control points) throughout the system understand the objectives of the arrangement and their responsibilities.
                  </label>
            </div>
          </div>
          <div className="row">
            <p>
              <h2>
                <b>1.2 Quality Policy and Objectives for Assurance Certification Scheme (ACS)</b>
                </h2>
            </p>
            <div className="col-lg-12">
                <label htmlFor="qualityPolicy" className="form-label">
                  Please State the Quality Policy and Objectives for the ACS:
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="qualityPolicy"
                      value=""
                  />
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>1.3.1 Scope of Phytosanitary Activities</b>
                </h2>
            </p>
            <div className="col-lg-12">
                <label htmlFor="scopeofPCActivities" className="form-label">
                  <b>Please describe the scope of phytosanitary activities approved under the ACS</b>
                  <p>This ACS arrangement applies to ______________________________________________exported to nominated countries as specified in section 1.3.2 of this manual, where a phytosanitary certificate is sought. Unless approved by NParks, any overseas new requirements or countries of destination not mentioned will not be included in the arrangement.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="scopeofPCActivities"
                      value=""
                  />
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>1.3.2 Schedule of Countries (final destinations)</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="country" className="form-label">
                  <b>Country</b>
                  <p>For countries which require phytosanitary certificate (state additional certifications if any) for exports</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="country"
                      value={scFormData.country}
                       onChange={handleChange}
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="product" className="form-label">
                  Product
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="product"
                      value={scFormData.product}
                       onChange={handleChange}
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="additionalCertReq" className="form-label">
                  Additional Certification Requirements
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="additionalCertReq"
                      value={scFormData.additionalCertReq}
                      onChange={handleChange}
                  />
              </div>
               <button
          className="btn btn-primary mt-3"
          onClick={handleAddSc}
        >
          Add
        </button>
            </div>
            {scheduleCountries.length > 0 && (
        <table className="table table-bordered mt-4">
          <thead>
            <tr>
              <th><span className="col-head">Country</span></th>
              <th><span className="col-head">Product</span></th>
              <th><span className="col-head">Additional Certification Requirements</span></th>
              <th><span className="col-head">Action</span></th>
            </tr>
          </thead>

          <tbody>
            {scheduleCountries.map((item, index) => (
              <tr key={index}>
                <td>{item.country}</td>
                <td>{item.product}</td>
                <td>{item.additionalCertReq}</td>
                <td>
                  <button className="btn btn-danger btn-sm" onClick={() => handleDeleteSc(index)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
          </div>
          {/* To do add Grid */}
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>1.3.3 Nomination of person, designation, and specific responsibilities for each operation - Indicate "main" person and "nominated" back up. The same person may perform multiple duties, but must have a nominated back up.</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="ocrPersonName" className="form-label">
                  <b>Overseas Country Requirements- Name of Person</b>
                  <p>Responsible to ensure that the company is aware of the changes and update the importing country requirements as importing countries frequently revises their requirement.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="ocrPersonName"
                      value={formData.ocrPersonName}
                      onChange={handleChange}
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="ocrPersonDesignation" className="form-label">
                  <b>Overseas Country Requirements- Designation of Person</b>
                  <p>Responsible to ensure that the company is aware of the changes and update the importing country requirements as importing countries frequently revises their requirement.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="ocrPersonDesignation"
                     value={formData.ocrPersonDesignation}
                      onChange={handleChange}
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="mgmtReviewPerson" className="form-label">
                   <b>Management Review- Name of Person</b>
                  <p>Responsible to conduct internal audits of the quality system at a minimum of one per annum. The person nominated with the responsibility will audit all areas of this manual to ensure that all procedures are being carried out. The results of audits shall be brought to the attention of the personnel responsible for the area audited and timely corrective action shall be taken on any deficiencies found in the audit. Any necessity to amend the ACS Manual will be brought to the attention of the owner/managing director and NParks. The audit and corrective actions will be documented as internal audit record and held at the premises.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="mgmtReviewPerson"
                      value={formData.mgmtReviewPerson}
                      onChange={handleChange}
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="mgmtReviewDesignation" className="form-label">
                   <b>Management Review- Designation of Person</b>
                  <p>Responsible to conduct internal audits of the quality system at a minimum of one per annum. The person nominated with the responsibility will audit all areas of this manual to ensure that all procedures are being carried out. The results of audits shall be brought to the attention of the personnel responsible for the area audited and timely corrective action shall be taken on any deficiencies found in the audit. Any necessity to amend the ACS Manual will be brought to the attention of the owner/managing director and NParks. The audit and corrective actions will be documented as internal audit record and held at the premises.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="mgmtReviewDesignation"
                      value={formData.mgmtReviewDesignation}
                      onChange={handleChange}
                  />
              </div>
               <button
          className="btn btn-primary mt-3"
          onClick={handleAdd}
        >
          Add
        </button>
            </div>
            {/* Table / Grid to show added records */}
      {records.length > 0 && (
        <table className="table table-bordered mt-4">
          <thead>
            <tr>
              <th><span className="col-head">Overseas Country Requirements- Name of Person</span></th>
              <th><span className="col-head">Overseas Country Requirements- Designation of Person</span></th>
              <th><span className="col-head">Management Review- Name of Person</span></th>
              <th><span className="col-head">Management Review- Designation of Person</span></th>
              <th><span className="col-head">Action</span></th>
            </tr>
          </thead>

          <tbody>
            {records.map((item, index) => (
              <tr key={index}>
                <td>{item.ocrPersonName}</td>
                <td>{item.ocrPersonDesignation}</td>
                <td>{item.mgmtReviewPerson}</td>
                <td>{item.mgmtReviewDesignation}</td>
                <td>
                  <button className="btn btn-danger btn-sm" onClick={() => handleDelete(index)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

          </div>
          {/* To do add Grid */}
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>2.1 Resource Management</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="dsExecutiveName" className="form-label">
                  <b>Duty Statement- Name of Chief Executive</b>
                  <p> • Overall responsible for the ACS arrangement • Ensuring appropriate staff are trained</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="dsExecutiveName"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="dsMgmtRep" className="form-label">
                  <b>Duty Statements- Name of Management Representative</b>
                  <p>• To be overall responsible for the procedures under this ACS arrangement (including internal auditing) e.g. Manager • Ensures that all day-to-day activities for carrying out all duties stated within this ACS arrangement are satisfactorily performed.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="dsMgmtRep"
                      value=""
                  />
              </div>
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>2.1.3 Generic Responsibilities- Indicate "main" person and "nominated" back up. The same person may perform multiple duties but must have a nominated back up.</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="pcInsPersonName" className="form-label">
                  <b>(a) Phytosanitary Inspections- Name of Person </b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="pcInsPersonName"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="pcInsDesignation" className="form-label">
                  <b>(a) Phytosanitary Inspections- Designation of Person</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="pcInsDesignation"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="supervisionPersonName" className="form-label">
                  <b>(b) Supervision of staff that are undertaking inspections- Name of Person</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="supervisionPersonName"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="supervisonDesignation" className="form-label">
                  <b>(b) Supervision of staff that are undertaking inspections- Designation of Person</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="supervisonDesignation"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="bkpsPersonName" className="form-label">
                  <b>(c) Ensure all staff is trained to carry out inspections including back up staff- Name of Person</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="bkpsPersonName"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="bkpsDesignation" className="form-label">
                  <b>(c) Ensure all staff is trained to carry out inspections including back up staff- Designation of Person</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="bkpsDesignation"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="pisepPersonName" className="form-label">
                  <b>(d) Correct product identification and segregation of export product- Name of Person</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="pisepPersonName"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="pisepDesignation" className="form-label">
                  <b>(d) Correct product identification and segregation of export product- Designation of Person</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="pisepDesignation"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="pcTreatmentPersonName" className="form-label">
                  <b>(e) Phytosanitary Treatments (including fumigation)- Name of Person</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="pcTreatmentPersonName"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="pcTreatmentDesignation" className="form-label">
                  <b>(e) Phytosanitary Treatments (including fumigation)- Designation of Person</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="pcTreatmentDesignation"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="correctiveActionPersonName" className="form-label">
                  <b>(f) Ensure corrective action undertaken if produce failed inspection- Name of Person</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="correctiveActionPersonName"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="correctiveActionDesignation" className="form-label">
                  <b>(f) Ensure corrective action undertaken if produce failed inspection- Designation of Person</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="correctiveActionDesignation"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="applicationCompletionPersonName" className="form-label">
                  <b>(g) Completion of Application of Phytosanitary Certificate and other document to NPARKS- Name of Person</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="applicationCompletionPersonName"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="applicationCompletionDesignation" className="form-label">
                  <b>(g) Completion of Application of Phytosanitary Certificate and other document to NPARKS- Designation of Person</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="applicationCompletionDesignation"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="quarantineInfoPerson" className="form-label">
                  <b>(h) Compilation of foreign Plant Quarantine information- Name of Person</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="quarantineInfoPerson"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="quarantineInfoDesignation" className="form-label">
                  <b>(h) Compilation of foreign Plant Quarantine information- Designation of Person</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="quarantineInfoDesignation"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="othersPersonName" className="form-label">
                  <b>(i) Others- Name of Person</b>
                  <p>Please specify</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="othersPersonName"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="others" className="form-label">
                  <b>(i) Others</b>
                  <p>Please specify</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="others"
                      value=""
                  />
              </div>
            </div>
          </div>
          {/* To do add Grid */}
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>2.2 Organisation Chart</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="orgChart" className="form-label">
                  <b>Submit Organisation Chart</b>
                  <ul>
                    <li>Only 1 file at 7 MB or less.</li>
                    <li>File name must have no more than 130 characters. Only letters (a-z), numbers (0-9), underscores (_), and hyphens (-) are allowed. Spaces in file names will be automatically replaced with underscores (_).</li>
                    <li>An organisation chart must be provided for this manual.  The chart should state the people and their positions, and the backup people identify in 2.1.3.</li>
                  </ul>
                </label>
                <input
                      type="file"
                      className="form-control"
                      name="orgChart"
                      value=""
                  />
              </div>
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>2.3.1 Training</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                
                  <b>To Maintain Training Records</b>
                  <p>Staff involved in export inspection will have to undergo a training course organised by NParks. The training will be on inspection techniques and pests and diseases identification. Other training programmes for the responsible staff mentioned in this manual include back-up staff should also be conducted by the company. Records of all training programmes would be filed at the premise address.</p>
                
                <input
                        type="checkbox"
                        className="form-check-input"
                        id="maintainTrainingRecords"
                        // checked={isNewAddress}
                        // onChange={handleCheckboxChangeEditMailingAddress}
                  />
                  <label
                        className="form-check-label"
                        htmlFor="maintainTrainingRecords"
                  >
                    Yes
                  </label>
              </div>
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>2.3.2 Names and Positions of 2 personnel who are qualified to conduct export inspections for the scope of this ACS arrangement</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="firstPersonnelName" className="form-label">
                  <b>Full Name of First Personnel</b>
                 
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="firstPersonnelName"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="firstPersonnelDesignation" className="form-label">
                  <b>First Personnel- Position within the Organisation</b>
                  
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="firstPersonnelDesignationtion"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="secondPersonnelName" className="form-label">
                   <b>Full Name of Second Personnel</b>
                  
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="secondPersonnelName"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="secondPersonnelDesignation" className="form-label">
                   <b>Second Personnel- Position within the Organisation</b>
                  
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="secondPersonnelDesignation"
                      value=""
                  />
              </div>
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>2.3.3 Name and Position of Personnel responsible for NPARKS training of new staff before permitted to undertake any export inspection.</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="personnelFullName" className="form-label">
                  <b>Full Name of Personnel</b>
                 <p>Responsible for NPARKS training of new staff before permitted to undertake any export inspection.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="personnelFullName"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="personnelPosition" className="form-label">
                  <b>Position of Personnel</b>
                  <p>Responsible for NPARKS training of new staff before permitted to undertake any export inspection.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="personnelPosition"
                      value=""
                  />
              </div>
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>2.3.4 Other staff in the various operations under ACS</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="personnelNameOthers" className="form-label">
                  <b>Name of Personnel</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="personnelNameOthers"
                      value={acsFormData.personnelNameOthers}
                       onChange={handleChange}
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="personnelPositionOthers" className="form-label">
                  <b>Position of Personnel</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="personnelPositionOthers"
                      value={acsFormData.personnelPositionOthers}
                       onChange={handleChange}
                  />
              </div>
               <button
          className="btn btn-primary mt-3"
          onClick={handleAddAcsStaff}
        >
          Add
        </button>
            </div>
            {/* Table / Grid to show added records */}
      {acsOtherStaffs.length > 0 && (
        <table className="table table-bordered mt-4">
          <thead>
            <tr>
              <th><span className="col-head">Name of Personnel</span></th>
              <th><span className="col-head">Position of Personnel</span></th>
              <th><span className="col-head">Action</span></th>
            </tr>
          </thead>

          <tbody>
            {acsOtherStaffs.map((item, index) => (
              <tr key={index}>
                <td>{item.personnelNameOthers}</td>
                <td>{item.personnelPositionOthers}</td>
                <td>
                  <button className="btn btn-danger btn-sm" onClick={() => handleDeleteAcsStaff(index)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
          </div>
          {/* To Add Grid */}
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>3.1 Quality Assurance System- Process Controls</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="rawMaterialCtrlPerson" className="form-label">
                  <b>Name of senior person responsible for co-ordination of control of raw material</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="rawMaterialCtrlPerson"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="expMaterialCntrlPerson" className="form-label">
                  <b>Name of senior person responsible for co-ordination of control of export material</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="expMaterialCntrlPerson"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="expCertDocCntrlPerson" className="form-label">
                  <b>Name of senior person responsible for co-ordination of control of export certification & document</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="expCertDocCntrlPerson"
                      value=""
                  />
              </div>
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>3.2.1 Quality Assurance System- Control of Product Identification and Traceability</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="productCtrlPersonName" className="form-label">
                  <b>Name of person responsible will keep a record of the raw materials received.</b>
                  <p>He will indicate the name of the grower, the premise or origin of the raw materials, quantity received, when and receipt by whom, etc.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="productCtrlPersonName"
                      value=""
                  />
              </div>             
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>3.2.2 Quality Assurance System- Control of Receipt of Raw Materials</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="receiptCtrlPersonName" className="form-label">
                  <b>Name of person responsible for identification, marking and labelling of raw materials to identify product and ensure traceability.</b>
                  <p>He will record plant name, identification methods, distinguishing marks (i.e. lot or batch number, grower number etc) etc. The identifying marks, if any, should be documented into an Export Inspection Record Book.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="receiptCtrlPersonName"
                      value=""
                  />
              </div>             
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>3.2.3 Quality Assurance System- Control of Export Inspection on Raw Materials</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="exportCtrlPersonName" className="form-label">
                  <b>Name of accredited inspector/s responsible for sampling plan criteria, sampling technique and inspection of raw materials.</b>
                  <p>Accredited inspector/s will follow specific instruction as per Annex 1 for the export inspection. Person responsible will ensure the whole consignment are all packed and arranged in lots and with distinguishing marks (i.e. lot or batch number, grower number etc) to identify the consignment before carrying out inspection. During inspection, if live pests or any visual signs of infection are detected, the consignment must be either rejected or sent for re- treatment. The rejection or details of re-treatment must be recorded into the Export Inspection Record.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="exportCtrlPersonName"
                      value=""
                  />
              </div>             
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>3.2.4 Quality Assurance System- Control of Selection/Rejection of Raw Materials</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="selectRejectCtrlPersonName" className="form-label">
                  <b>Name of person responsible for segregation of selected materials from rejected materials.</b>
                  <p>He will also be responsible for the disposal of the rejected materials and/or for the re-processing of the raw materials (if any) in order for the materials to be suitable for re-inspection. He will record all details of the rejected materials and reasons for rejection (eg detection of what pests on what type of materials, etc), and corrective actions taken. He will also record all disposal of rejected materials against the origin and grower source for traceability.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="selectRejectCtrlPersonName"
                      value=""
                  />
              </div>             
            </div>
          </div>
           <br></br>
          <div className="row">
            <p>
              <h2>
                <b>3.3.1 Control of Export Material- Control of Phytosanitary Treatments</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="pcTreatmentCtrlPersonName" className="form-label">
                  <b>Name of accredited inspector/s responsible for phytosanitary treatments of raw materials (including fumigation) carried out at (a) Field stage, (b) Processing stage, and (c) Pre-departure stage.</b>
                  <p>He will record all treatment/processing done in the Treatment Record and also indicate special treatment for compliance to importing countries requirements.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="pcTreatmentCtrlPersonName"
                      value=""
                  />
              </div>             
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>3.3.2 Control of Export Material- Control of Sorting</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="sortingCtrlPersonName" className="form-label">
                  <b>Name of person responsible for segregation of treated materials for export and untreated raw materials.</b>
                  <p>The identifying marks, if any, should be documented into an Export Inspection Record Book. Please document below if company has other ways to ensure the lot is traceable.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="sortingCtrlPersonName"
                      value=""
                  />
              </div>             
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>3.3.3 Control of Export Material- Control of End Point Inspection</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="endPointCtrlPersonName" className="form-label">
                  <b>Name of accredited inspector/s responsible for sampling plan criteria, sampling technique and inspection of selected treated materials.</b>
                  <p>Accredited inspector/s will follow specific instruction as per Annex 1 for the export inspection. Person responsible will ensure the whole consignment are all packed and arranged in lots and with distinguishing marks (i.e. lot or batch number, grower number etc) to identify the consignment before carrying out inspection. During inspection, if live pests or any visual signs of infection are detected, the consignment must be either rejected or sent for re- treatment. The rejection or details of re-treatment must be recorded into the Export Inspection Record.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="endPointCtrlPersonName"
                      value=""
                  />
              </div>             
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>3.3.4 Control of Export Material- Control of Product Selection/ Rejection</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="exportSelectRejectCtrlPersonName" className="form-label">
                  <b>Name of person responsible for the separation of the selected materials from the rejected materials.</b>
                  <p>He will remove the entire lot that has failed the inspection away from the inspection area and the packing area to a designated area which is at least 10 metres away.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="exportSelectRejectCtrlPersonName"
                      value=""
                  />
              </div>

              <div className="pos-rel mt-2">
                <label htmlFor="selRejectLayoutPlan" className="form-label">
                  <b>Submit Layout Plan and indicate method of segregation of selected and rejected products</b>
                  <ul>
                    <li>Only 1 file at 7 MB or less.</li>
                    <li>File name must have no more than 130 characters. Only letters (a-z), numbers (0-9), underscores (_), and hyphens (-) are allowed. Spaces in file names will be automatically replaced with underscores (_).</li>
                    <li>Nominate the area and highlight this on the layout of the establishment. Please indicate how the lots are identified as failed.</li>
                  </ul>
                  <p>Please also indicate where the corrective actions will be recorded.</p>
                </label>
                <input
                      type="file"
                      className="form-control"
                      name="selRejectLayoutPlan"
                      value=""
                  />
              </div>

              <div className="pos-rel mt-2">
                <label htmlFor="reProcessingPersonName" className="form-label">
                  <b>Person responsible for the re-processing of the rejected product.</b>
                  <p>The products may be re-presented for inspection after reconditioning (i.e. further treatment for pest infestation or sorted because of disease incidence). When re-presented for inspection, the whole procedure on Control of End Point Inspection must be carried out again.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="reProcessingPersonName"
                      value=""
                  />
              </div>                          
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>3.3.5 Control of Export Material- Control of Packing/Storage</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="packingStorageCtrlPersonName" className="form-label">
                  <b>Name of person responsible for storage of the selected, treated and passed export inspection materials as the final export product.</b>
                  <p>He will ensure that the final export product is stored in a separate room or at least 10 metres away from the inspection table and packing area and from any non-inspected or rejected produce. The storage area shall be free of pests, which could re-infest the inspected product. The product must be identified as passed inspection and for what destination.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="packingStorageCtrlPersonName"
                      value=""
                  />
              </div>

              <div className="pos-rel mt-2">
                <label htmlFor="packingStorageLayoutPlan" className="form-label">
                  <b>Submit Layout Plan and indicate method of segregation of selected and rejected products</b>
                  <ul>
                    <li>Only 1 file at 7 MB or less.</li>
                    <li>File name must have no more than 130 characters. Only letters (a-z), numbers (0-9), underscores (_), and hyphens (-) are allowed. Spaces in file names will be automatically replaced with underscores (_).</li>
                    
                  </ul>
                  <p>Please also explain how the product will be identified as passed, and where it will be stored.</p>
                </label>
                <input
                      type="file"
                      className="form-control"
                      name="packingStorageLayoutPlan"
                      value=""
                  />
              </div>                
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>3.3.6 Control of Export Material- Control of Cleaning and Waste Disposal</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="cleaningWastePersonName" className="form-label">
                  <b>Name of person responsible for the cleaning and sanitation of the packing shed and removal of waste product.</b>
                  <p>He/She will put up a cleaning schedule for the workers and conduct regular inspection at the various areas.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="cleaningWastePersonName"
                      value=""
                  />
              </div>

              <div className="pos-rel mt-2">
                <label htmlFor="wasteDisposalReason" className="form-label">
                  <b>Please explain how the waste will be disposed</b>
                  
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="wasteDisposalReason"
                      value=""
                  />
              </div>
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>3.3.7 Control of Export Material- Control of Transport</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="transportCtrlPersonName" className="form-label">
                  <b>Name of person responsible for the the loading of the final export product in a vehicle that could not cause any cross contamination.</b>
                  <p>(e.g. not in a vehicle used for imported cut flowers or plants or cut flowers or plants for domestic sale).</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="transportCtrlPersonName"
                      value=""
                  />
              </div>

              <div className="pos-rel mt-2">
                <label htmlFor="crossContamination" className="form-label">
                  <b>Submit arrangement to avoid cross contamination</b>
                  <ul>
                    <li>Only 1 file at 7 MB or less.</li>
                    <li>File name must have no more than 130 characters. Only letters (a-z), numbers (0-9), underscores (_), and hyphens (-) are allowed. Spaces in file names will be automatically replaced with underscores (_).</li>
                    <li>If the transport of the final export product is mixed with non- inspected produce in one vehicle, please detail the arrangement to ensure no cross contamination will occur.</li>
                  </ul>
                  
                </label>
                <input
                      type="file"
                      className="form-control"
                      name="crossContamination"
                      value=""
                  />
              </div>                
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>3.3.8 Control of Export Material- Control of Monitoring and Measuring Devices</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="monitorMeasureCtrlPersonName" className="form-label">
                  <b>Name of person responsible for the servicing, calibration and good operational order of measuring equipment and devices such as tools and equipment used for phytosanitary activities, inspection equipment, renewal of operator licences (if applicable).</b>
                  
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="monitorMeasureCtrlPersonName"
                      value=""
                  />
              </div>     
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>4.1.1 Phytosanitary Risk Managment Program- Submit flow chart for Critical Process Control</b>
              </h2>
            </p>
              <div className="pos-rel mt-2">
                <label htmlFor="cpcFlowChart" className="form-label">
                  <b>Submit flow chart for Critical Process Control</b>
                  <ul>
                    <li>Only 1 file at 7 MB or less.</li>
                    <li>File name must have no more than 130 characters. Only letters (a-z), numbers (0-9), underscores (_), and hyphens (-) are allowed. Spaces in file names will be automatically replaced with underscores (_).</li>
                    <li>The critical process control flow chart from the arrival of raw material to the storage of the final export product.</li>
                  </ul>
                  
                </label>
                <input
                      type="file"
                      className="form-control"
                      name="cpcFlowChart"
                      value=""
                  />
              </div>                
            </div>
            <br></br>
          <div className="row">
            <p>
              <h2>
                <b>4.1.2 Phytosanitary Risk Managment Program- Submit standards used for the Critical Process Control</b>
              </h2>
            </p>
              <div className="pos-rel mt-2">
                <label htmlFor="cpcStandards" className="form-label">
                  <b>Submit standards used for the Critical Process Control</b>
                  <ul>
                    <li>Only 1 file at 7 MB or less.</li>
                    <li>File name must have no more than 130 characters. Only letters (a-z), numbers (0-9), underscores (_), and hyphens (-) are allowed. Spaces in file names will be automatically replaced with underscores (_).</li>
                    <li>Standards Used In The Above Critical Process Control Are Defined As Follow:</li>
                    <li>(Different standards are allowed due to different import requirements)</li>
                  </ul>
                  
                </label>
                <input
                      type="file"
                      className="form-control"
                      name="cpcStandards"
                      value=""
                  />
              </div>                
            </div>
            <br></br>
          <div className="row">
            <p>
              <h2>
                <b>4.1.3 Phytosanitary Risk Managment Program- Submit list of inspection standards for receipt of raw materials</b>
              </h2>
            </p>
              <div className="pos-rel mt-2">
                <label htmlFor="rawMaterialsStandards" className="form-label">
                  <b>Submit flow chart for Critical Process Control</b>
                  <ul>
                    <li>Only 1 file at 7 MB or less.</li>
                    <li>File name must have no more than 130 characters. Only letters (a-z), numbers (0-9), underscores (_), and hyphens (-) are allowed. Spaces in file names will be automatically replaced with underscores (_).</li>
                    <li>Raw Material On Arrival: list out the inspection standards for acceptance and rejection of the raw materials.</li>
                  </ul>
                  
                </label>
                <input
                      type="file"
                      className="form-control"
                      name="rawMaterialsStandards"
                      value=""
                  />
              </div>                
            </div>
            <br></br>
          <div className="row">
            <p>
              <h2>
                <b>4.1.4 Phytosanitary Risk Managment Program- Submit list of phytosanitary treatments for raw materials</b>
              </h2>
            </p>
              <div className="pos-rel mt-2">
                <label htmlFor="rawMaterialPCTreatment" className="form-label">
                  <b>Submit list of phytosanitary treatments for raw materials</b>
                  <ul>
                    <li>Only 1 file at 7 MB or less.</li>
                    <li>File name must have no more than 130 characters. Only letters (a-z), numbers (0-9), underscores (_), and hyphens (-) are allowed. Spaces in file names will be automatically replaced with underscores (_).</li>
                    <li>Treatment /Processing of the Raw Material: list out the various treatment measures that are going to apply to the raw material; treatment measures must be specific and can be measured (e.g. water jet cleaning for 30 seconds, hand wash on every pieces for xxx minutes, soaking into 0.005% imidacloprid for 60 minutes.)</li>
                  </ul>
                  
                </label>
                <input
                      type="file"
                      className="form-control"
                      name="rawMaterialPCTreatment"
                      value=""
                  />
              </div>                
            </div>
            <br></br>
          <div className="row">
            <p>
              <h2>
                <b>4.1.5 Phytosanitary Risk Managment Program- Submit list of selection standards for treated materials</b>
              </h2>
            </p>
              <div className="pos-rel mt-2">
                <label htmlFor="treatedMaterialStandards" className="form-label">
                  <b>Submit list of selection standards for treated material</b>
                  <ul>
                    <li>Only 1 file at 7 MB or less.</li>
                    <li>File name must have no more than 130 characters. Only letters (a-z), numbers (0-9), underscores (_), and hyphens (-) are allowed. Spaces in file names will be automatically replaced with underscores (_).</li>
                    <li>Selection of The Treated Material Prior To Packing: list out the selection standards if any and elaborate on how to implement such standards</li>
                  </ul>
                  
                </label>
                <input
                      type="file"
                      className="form-control"
                      name="treatedMaterialStandards"
                      value=""
                  />
              </div>                
            </div>
            <br></br>
          <div className="row">
            <p>
              <h2>
                <b>4.1.6 Phytosanitary Risk Managment Program- Submit list packing standards for final export product</b>
              </h2>
            </p>
              <div className="pos-rel mt-2">
                <label htmlFor="finalExpProductStandards" className="form-label">
                  <b>Submit list packing standards for final export product</b>
                  <ul>
                    <li>Only 1 file at 7 MB or less.</li>
                    <li>File name must have no more than 130 characters. Only letters (a-z), numbers (0-9), underscores (_), and hyphens (-) are allowed. Spaces in file names will be automatically replaced with underscores (_).</li>
                    <li>Packing Standards for The Final Export Product: list out the packing standards to ensure no cross contamination is possible during the in-transit stages.</li>
                  </ul>
                  
                </label>
                <input
                      type="file"
                      className="form-control"
                      name="finalExpProductStandards"
                      value=""
                  />
              </div>                
            </div>
            <br></br>
          <div className="row">
            <p>
              <h2>
                <b>4.1.7 Phytosanitary Risk Managment Program- Submit list of standards for End Point Inspection</b>
              </h2>
            </p>
              <div className="pos-rel mt-2">
                <label htmlFor="endPointInsStandard" className="form-label">
                  <b>Submit flow chart for Critical Process Control</b>
                  <ul>
                    <li>Only 1 file at 7 MB or less.</li>
                    <li>File name must have no more than 130 characters. Only letters (a-z), numbers (0-9), underscores (_), and hyphens (-) are allowed. Spaces in file names will be automatically replaced with underscores (_).</li>
                    
                  </ul>
                  
                </label>
                <input
                      type="file"
                      className="form-control"
                      name="endPointInsStandard"
                      value=""
                  />
              </div>                
            </div>
            <br></br>
          <div className="row">
            <p>
              <h2>
                <b>4.1.8 Phytosanitary Risk Managment Program- Submit layout plan of packing shed</b>
              </h2>
            </p>
              <div className="pos-rel mt-2">
                <label htmlFor="packingShedLayoutPlan" className="form-label">
                  <b>Submit layout plan of packing shed</b>
                  <ul>
                    <li>Only 1 file at 7 MB or less.</li>
                    <li>File name must have no more than 130 characters. Only letters (a-z), numbers (0-9), underscores (_), and hyphens (-) are allowed. Spaces in file names will be automatically replaced with underscores (_).</li>
                    <li>Provide a simple plan of the packing shed, showing location of major items of equipments, receiving and dispatch areas, sorting, grading and inspection area, disinfection tanks, storage area for inspected product, site for rejected produce, waste disposal site, etc.</li>
                  </ul>
                  
                </label>
                <input
                      type="file"
                      className="form-control"
                      name="packingShedLayoutPlan"
                      value=""
                  />
              </div>                
            </div>
            <br></br>
          <div className="row">
            <p>
              <h2>
                <b>4.2 Hazard Analysis- The product line should be analysed to identify the critical points within the process, which must be controlled to ensure that the quality of the product is not jeopardised</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="criticalOperation" className="form-label">
                  <b>Critical Operation: The procedure or operation which may lead to potential risk</b>
                  <p>Please identify and explain the critical operation which must be controlled to ensure that the quality of the product is not jeopardised.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="criticalOperation"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="potentialRisk" className="form-label">
                  <b>Potential Risk: The outcome if anything goes wrong with this procedure or operation.</b>
                  <p>Please identify and explain the potential risk which must be controlled to ensure that the quality of the product is not jeopardised.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="potentialRisk"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="criticalControlPts" className="form-label">
                   <b>Critical control points: The points to be critically monitored or controlled in a process to ensure that the risk does not happen again.</b>
                  <p>Please identify and explain the Critical control points which must be controlled to ensure that the quality of the product is not jeopardised.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="criticalControlPts"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="monitoringProcedure" className="form-label">
                   <b>Monitoring procedure: An inspection or monitoring setup to ensure that the procedures are carried out correctly or supervision to ensure the procedures is adhered to correctly.</b>
                  <p>Please identify and explain the Monitoring procedure which must be adhered to ensure that the quality of the product is not jeopardised.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="monitoringProcedure"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="recordingFrequency" className="form-label">
                   <b>Recording and their frequency: Record the monitoring procedure and frequencies in a sheet or chart.</b>
                  <p>Please identify and explain the frequency of recording the monitoring procedure, which must be adhered to ensure that the quality of the product is not jeopardised.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="recordingFrequency"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="operationVerifyingPerson" className="form-label">
                   <b>Name of person responsible to ensure that this operation or procedure is carried out according to the specification or procedure</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="operationVerifyingPerson"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="correctionPersonName" className="form-label">
                   <b>Name of person responsible for correcting a situation if the product is found to be outside the specification</b>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="correctionPersonName"
                      value=""
                  />
              </div>
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>5.1 Control of Export Documents</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="exportDocCtrlPersonName" className="form-label">
                  <p>Name of person responsible for communication with importing countries and NPARKS on export document matters</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="exportDocCtrlPersonName"
                      value=""
                  />
              </div>     
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>5.2 Control of Phytosanitary Certificate</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="pceApplicationCtrlPersonName" className="form-label">
                  <b>Name of person responsible for the electronic Application for Phytosanitary Certificate</b>
                  <p>The Export Inspection record will be forwarded to the accredited inspector for endorsement after he/she has passed the export inspection and record the detail into the Export Inspection Record. The accredited inspector would initial his/her name in the ‘Signature of Inspecting Officer and Date of inspection’ column in the export inspection record.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="pceApplicationCtrlPersonName"
                      value=""
                  />
              </div>    
              <div className="pos-rel mt-2">
                <label htmlFor="pvNoIssuedCtrlPersonName" className="form-label">
                  <p>Name of person responsible for the insertion of the Phytosanitary Certificate number in the “PC No. Issued” column of the Export Inspection Record</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="pvNoIssuedCtrlPersonName"
                      value=""
                  />
              </div>     
              <div className="pos-rel mt-2">
                <label htmlFor="duplicateCopiesCtrlPersonName" className="form-label">
                  <p>Name of person responsible for the safe keeping of the duplicate copies of Phytosanitary Certificates issued by NPARKS</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="duplicateCopiesCtrlPersonName"
                      value=""
                  />
              </div>      
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>5.3 Control of Report of Overseas Rejection</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="overseasRejectionCtrlPersonName" className="form-label">
                  <b>Name of person responsible for recording of any overseas rejection or consignment that is fumigated at the point of entry due to pests’ infestation in the Overseas Rejection Record.</b>
                  <p>He/She will also investigate and record all findings including history of that consignment in the Overseas Rejection Record.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="overseasRejectionCtrlPersonName"
                      value=""
                  />
              </div>     
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>5.4 Records</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="acsCtrlPersonName" className="form-label">
                  <p>Name of person responsible for a Record System to compile all records of activities taken under the ACS including control of non-conforming product, corrective actions and preventive actions</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="acsCtrlPersonName"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="rawMaterialInsRecord" className="form-label">
                  <p>Name of person responsible for the safe keeping of Form 1: Raw Material Inspection Record, used in ACS</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="rawMaterialInsRecord"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="acsTreatmentRecord" className="form-label">
                   Name of person responsible for the safe keeping of Form 2: Treatment Record, used in ACS
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="acsTreatmentRecord"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="acsInspectionRecord" className="form-label">
                Name of person responsible for the safe keeping of Form 3: Export Inspection Record, used in ACS
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="acsInspectionRecord"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="acsRejectionRecord" className="form-label">
                Name of person responsible for the safe keeping of Form 4: Overseas Rejection File, used in ACS
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="acsRejectionRecord"
                      value=""
                  />
              </div>
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>6. Amendment to the ACS Manual</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="acsManualDocPerson" className="form-label">
                 Name of person responsible to document changes to the ACS manual
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="acsManualDocPerson"
                      value=""
                  />
              </div>     
             
              <div className="pos-rel mt-2">
                <label htmlFor="approvalChangeCtrlPerson" className="form-label">
                <b>Name of person responsible for informing NPARKS of changes to the ACS Manual and for sending the ACS manual to NPARKS highlighting the changes for approval prior to commencement of changes</b>
                <p>NPARKS will contact the company to accept or reject the amendment by correspondence within one month. The company must document this confirmation and NPARKS will ensure that their correspondence is documented and filed.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="approvalChangeCtrlPerson"
                      value=""
                  />
              </div>     
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>7. Others</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="otherAcsInfo" className="form-label">
                  <b>Please submit any other information which may be relevant to the ACS</b>(Optional)
                  <ul>
                    <li>Only 1 file at 7 MB or less.</li>
                    <li>File name must have no more than 130 characters. Only letters (a-z), numbers (0-9), underscores (_), and hyphens (-) are allowed. Spaces in file names will be automatically replaced with underscores (_).</li>
                    
                  </ul>
                </label>
                <input
                      type="file"
                      className="form-control"
                      name="otherAcsInfo"
                      value=""
                  />
              </div> 
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>Annex I: Process Flow Chart for Phytosanitary Inspection and Treatment</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="rawMaterialInsPerson" className="form-label">
                  <b>Name of Person Responsible for Arrival of Raw- Material and Inspection</b>
                  <p>Standards and Procedure: To inspect the raw- materials (from own farm or from suppliers) as per the following: 1. Sample Plan 2. Rejection criteria 3. Target pests (e.g. White fly, snail, caterpillar, etc)</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="rawMaterialInsPerson"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="treatmentProcessingPerson" className="form-label">
                  <b>Name of Person Responsible for Treatment/ processing of raw- materials after the inspection</b>
                  <p>Standards and Procedure: Washing or dipping in chemical solution as per the attached standards for dis-infestation treatment.</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="treatmentProcessingPerson"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="postTreatmentIncPerson" className="form-label">
                   <b>Name of Person Responsible for Post Treatment Inspection</b>
                  <p>Standards & Procedures: Post treatment inspection will follow the standard</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="postTreatmentIncPerson"
                      value=""
                  />
              </div>
              <div className="pos-rel mt-2">
                <label htmlFor="endPointInsPerson" className="form-label">
                   <b>Name of Person Responsible for End point inspection</b>
                  <p>Standards & Procedure: Lot selection and sample inspection will follow the attached standard for end point inspection. 1. Sample Plan 2. Rejection criteria</p>
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="endPointInsPerson"
                      value=""
                  />
              </div>
            </div>
          </div>
          <br></br>
          <div className="row">
            <p>
              <h2>
                <b>Annex: Special Requirement if any</b>
              </h2>
            </p>
            <div className="col-lg-12">
              <div className="pos-rel mt-2">
                <label htmlFor="splRequirements" className="form-label">
                  To provide inputs for special requirement if any
                </label>
                <input
                      type="text"
                      className="form-control"
                      name="splRequirements"
                      value=""
                  />
              </div>     
            </div>
          </div>
          <br></br>
          <div className="row">
            <div className="col-md-4">
      <button
            className="btn btn-d btn-primary"
            name="submitacs"
            type="button"
            
          >
            Submit
          </button>
          </div>
          {/* <div className="col-md-4">
          <button type="button" onClick={handleCancel}>Cancel</button>
          </div> */}
          </div>
        </div>
      </div>
      {/* </form> */}
      </Contaier>
    <Footer />
    </>
  );
}

export default AcsApplicationForm;